import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { LyTheme } from '../../theme.service';
var LyColor = /** @class */ (function () {
    function LyColor(theme, renderer, elementRef) {
        this.theme = theme;
        this.renderer = renderer;
        this.elementRef = elementRef;
        /** Default color */
        this._color = 'primary';
        this.prefix = 'color';
    }
    Object.defineProperty(LyColor.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (color) {
            this._color = color;
            var key = "" + this.prefix + (color || this._color);
            var newStyle = this.theme.createStyle("ly-" + key, this.css.bind(this), color);
            this.theme.updateClass(this.elementRef, this.renderer, newStyle.id, this._lastClass);
            this._lastClass = newStyle.id;
        },
        enumerable: true,
        configurable: true
    });
    LyColor.prototype.css = function (color) {
        return "color:" + this.theme.colorOf(color) + ";";
    };
    LyColor.decorators = [
        { type: Directive, args: [{
                    selector: '[color]'
                },] },
    ];
    /** @nocollapse */
    LyColor.ctorParameters = function () { return [
        { type: LyTheme, },
        { type: Renderer2, },
        { type: ElementRef, },
    ]; };
    LyColor.propDecorators = {
        "color": [{ type: Input, args: ['color',] },],
    };
    return LyColor;
}());
export { LyColor };
//# sourceMappingURL=color.directive.js.map